<template>
    <v-touch
        @swiperight="swiperright"
        class="wrapper"
    >
        <div class="customerEntry commonFormStyles">
            <van-nav-bar
                :title="title"
                left-text="客户管理"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <section class="showFontBtn">
                <van-collapse v-model="activeNames">
                    <van-collapse-item name="1">
                        <div
                            slot="title"
                            class="title"
                        >
                            <i class="iconfont icondingdan"></i>基础信息
                        </div>
                        <van-form ref="materialPlanForm">
                            <van-cell
                                :value="customerData.no"
                                title="客户编号"
                                class="customerNub"
                                :icon="require('@/assets/images/icons/icon_gy_1.png')"
                            ></van-cell>
                            <van-field
                                v-model="customerData.name"
                                class="required"
                                label="客户名称"
                                placeholder="请填写客户名称（必填）"
                                input-align="right"
                                :left-icon="require('@/assets/images/icons/icon_33.png')"
                                scroll-to-error
                                :rules="[{ required: true, message: '请填写客户名称' }]"
                            ></van-field>
                            <van-field
                                readonly
                                clickable
                                name="picker"
                                :value="customerData.nature_name"
                                class="required"
                                label="客户性质"
                                input-align="right"
                                placeholder="请选择客户性质（必选）"
                                :left-icon="require('@/assets/images/icons/icon_33.png')"
                                @click="openPicker('customerNature')"
                                scroll-to-error
                                :rules="[{ required: true, message: '请选择客户性质' }]"
                                is-link
                            ></van-field>
                            <van-field
                                v-model="customerData.license_code"
                                label="统一社会信用代码"
                                placeholder="请输入统一社会信用代码（必填）"
                                class="required"
                                input-align="right"
                                :left-icon="require('@/assets/images/icons/icon_33.png')"
                                scroll-to-error
                                :rules="[{ required: true, message: '请输入统一社会信用代码' }]"
                            ></van-field>
                            <van-field
                                readonly
                                clickable
                                name="picker"
                                :value="customerData.level_name"
                                class="required"
                                label="客户等级"
                                input-align="right"
                                placeholder="请选择客户等级（必选）"
                                :left-icon="require('@/assets/images/icons/icon_33.png')"
                                @click="openPicker('customerLevel')"
                                scroll-to-error
                                :rules="[{ required: true, message: '请选择客户等级' }]"
                                is-link
                            ></van-field>
                            <van-field
                                v-model="customerData.address"
                                label="客户地址"
                                placeholder="请输入客户地址"
                                input-align="right"
                                :left-icon="require('@/assets/images/icons/icon_2.png')"
                            ></van-field>
                            <van-field
                                readonly
                                clickable
                                name="picker"
                                :value="customerData.rel_client_name"
                                label="关联企业"
                                input-align="right"
                                placeholder="请选择关联企业"
                                :left-icon="require('@/assets/images/icons/icon_33.png')"
                                @click="openEnterprise"
                                is-link
                            ></van-field>
                            <van-cell
                                title="是否是上级单位"
                                :icon="require('@/assets/images/icons/icon_gy_1.png')"
                            >
                                <van-radio-group class="van_right" v-model="customerData.is_parent" direction="horizontal">
                                    <van-radio :name="true">
                                        是
                                    </van-radio>
                                    <van-radio :name="false">
                                        否
                                    </van-radio>
                                </van-radio-group>
                            </van-cell>
                            <van-cell
                                :value="customerData.creator"
                                title="登记人"
                                :icon="require('@/assets/images/icons/icon_33.png')"
                            ></van-cell>
                            <van-cell
                                :value="customerData.created"
                                title="登记时间"
                                :icon="require('@/assets/images/icons/icon_gy_1.png')"
                            ></van-cell>
                            <van-field
                                v-model="customerData.remarks"
                                rows="2"
                                autosize
                                type="textarea"
                                maxlength="80"
                                class="iconfont iconbeizhu textarea"
                                placeholder="请在此处输入备注信息"
                            ></van-field>
                        </van-form>
                    </van-collapse-item>
                </van-collapse>
                <van-popup
                    round
                    v-model="isPicker"
                    position="bottom"
                >
                    <van-picker
                        show-toolbar
                        :title="columnsTitle"
                        :columns="columns"
                        @cancel="onCancel"
                        @confirm="confirmSelection"
                    ></van-picker>
                </van-popup>
            </section>
            <footer class="commonFormBtns">
                <van-button type="info" @click="preservation">
                    保存
                </van-button>
            </footer>
        </div>
    </v-touch>
</template>
<script>
import Utils from '@/utils/util';

export default {
    // 录入客户
    name: 'customer-entry',
    beforeRouteLeave(to, from, next) {
        if (to.path !== '/affiliatedEnterprises') {
            this.$store.commit('noKeepAlive', 'customer-entry');
        }
        next();
    },
    components: {},
    props: {},
    data() {
        return {
            title: '',
            activeNames: ['1'],
            // 选择器状态
            isPicker: false,
            // 选择器数据
            columnsTitle: '',
            // 选择器数据
            columns: [],
            // 当前打开选择器对象
            openObjects: '',
            // 客户类型
            customerType: [],
            // 客户性质选择数据
            customerNatureData: [],
            // 客户等级选择数据
            customerLevelData: [],
            // 是否是编辑
            isEdit: false,
            customerData: {
                // 客户编号
                no: '',
                // 客户类型
                type: '',
                // 客户类型名称
                type_name: '',
                // 客户名称
                name: '',
                // 统一社会信用代码
                license_code: '',
                // 企业关联关系
                rel_client: '',
                // 企业关联关系名称
                rel_client_name: '',
                // 是否上级单位
                is_parent: false,
                // 客户性质
                nature: '002-XZ0-11',
                // 客户性质名称
                nature_name: '内资企业',
                // 客户地址
                address: '',
                // 客户等级
                level: '',
                // 客户等级名称
                level_name: '',
                // 创建人
                creator: this.$takeTokenParameters('Name'),
                // 创建时间
                created: '',
                // 编号索引
                auto_index: 0,
                // 备注
                remarks: '',
                // 父页面路由
                parentPageName: '',
            },
        };
    },
    computed: {},
    watch: {},
    created() {
        this.customerData.created = Utils.timeFormat(new Date(), 'yyyy-MM-dd');
        // 客户类型
        this.getbycode('customerType', '002-FL0');
        // 客户性质选择数据赋值
        this.getbycode('customerNatureData', '002-XZ0');
        // 客户等级选择数据赋值
        this.getbycode('customerLevelData', '002-DJ0');

        // 参数里有data是编辑，没有是新增
        if (this.$route.query.data) {
            // 录入客户数据赋值
            this.customerData = this.$route.query.data;
            this.title = this.customerData.type_name;
            // 是否是编辑
            this.isEdit = true;
        } else {
            // 客户类型赋值
            this.customerData.type = this.$route.query.customerType;
            // 父页面路由
        }
        this.parentPageName = this.$route.query.parentPageName;
    },
    activated() {
        // 参数里有confirmSelection是选择关联企业返回
        if (this.$route.query.confirmSelection) {
            // 录入客户数据赋值
            this.customerData = this.$route.query.confirmSelection;
            // 是否是编辑
            this.isEdit = this.$route.query.isEdit;
        }
    },
    mounted() { },
    destroyed() { },
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.push({ path: this.parentPageName });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.push({ path: this.parentPageName });
        },
        // 时间补0
        add0(m) {
            return m < 10 ? '0' + m : m;
        },
        // 打开选择器
        openPicker(type) {
            this.openObjects = type;
            this.columns = [];
            if (type === 'customerNature') {
                if (this.customerNatureData.length > 0) {
                    this.customerNatureData.forEach(item => {
                        this.columns.push(item.name);
                    });
                }
            } else if (type === 'customerLevel') {
                if (this.customerLevelData.length > 0) {
                    this.customerLevelData.forEach(item => {
                        this.columns.push(item.name);
                    });
                }
            }
            this.isPicker = true;
        },
        // 选择器确认选择
        confirmSelection(value, index) {
            if (this.openObjects === 'customerNature') {
                this.customerData.nature = this.customerNatureData[index].code;
                this.customerData.nature_name = this.customerNatureData[index].name;
            } else if (this.openObjects === 'customerLevel') {
                this.customerData.level = this.customerLevelData[index].code;
                this.customerData.level_name = this.customerLevelData[index].name;
            }
            this.isPicker = false;
        },
        // 取消选择器
        onCancel() {
            this.isPicker = false;
        },
        // 通过code拉取字典信息
        async getbycode(type, parentCode) {
            await this.$axios.get('/interfaceApi/baseinfo/dictionary_config/getlist?parent_code=' + parentCode)
                .then(res => {
                    this[type] = res;
                    if (type === 'customerType') {
                        res.forEach(item => {
                            if (item.code === this.customerData.type) {
                                this.title = item.name;
                                this.customerData.type_name = item.name;
                            }
                        });
                    }
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 打开选择关联企业
        openEnterprise() {
            this.$router.isBack = 2;
            this.$router.replace({
                path: '/affiliatedEnterprises',
                query: {
                    data: this.customerData,
                    isEdit: this.isEdit,
                },
            });
        },
        // 保存
        preservation() {
            this.$refs.materialPlanForm.validate().then(async () => {
                if (this.isEdit) {
                    this.editRequest();
                } else {
                    // 生成客户编号
                    this.customerData.no = await this.getAutoCode();
                    this.saveRequest();
                }
            });
        },
        // 新增保存
        saveRequest() {
            this.$axios
                .post('/interfaceApi/sale/client_manager/add_client', this.customerData)
                .then(() => {
                    this.$toast.success('添加成功！');
                    this.$router.isBack = 1;
                    this.$router.push({ path: this.parentPageName });
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 编辑保存
        editRequest() {
            this.$axios
                .put(`/interfaceApi/sale/client_manager/modify_client/${this.customerData.no}`, this.customerData)
                .then(res => {
                    this.$toast.success(res);
                    this.$router.isBack = 1;
                    this.$router.push({ path: this.parentPageName });
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 生成客户编号
        getAutoCode() {
            const code = this.customerData.created.split('-').join('');
            return this.$axios.$get(`interfaceApi/baseinfo/dictionary_config/getno_custom?code=KH${code}`);
        },
    },
};
</script>
<style lang="stylus">
</style>
